'use strict';

define('forum/header/notifications', ['components', 'alerts'], function (components, alerts) {
	const notifications = {};

	notifications.prepareDOM = function () {
		socket.removeListener('event:new_notification', onUpdateCount);
		socket.on('event:new_notification', onUpdateCount);

		socket.removeListener('event:notifications.updateCount', onUpdateCount);
		socket.on('event:notifications.updateCount', onUpdateCount);
		onUpdateCount();
	};

	function onUpdateCount() {
		socket.emit('notifications.getCount', function (err, count) {
			if (err) {
				return alerts.error(err);
			}
			const notificationsEl = components.get('notifications');
			count = Math.max(0, count);

			notificationsEl.toggleClass('has-unread', count > 0);
		});
	}

	return notifications;
});
